module.exports = __webpack_public_path__ + "static/webd-b858cec9a5d4844267d12a54340ec15d.png";